import { render, staticRenderFns } from "./SwiperTeam.vue?vue&type=template&id=353b7016&"
import script from "./SwiperTeam.vue?vue&type=script&lang=js&"
export * from "./SwiperTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports